"use client";
import React, { useContext } from "react";
import {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import ChPromo_1 from "/public/assets/goat-spins-hp-slider-1.png";
import ChPromo_2 from "/public/assets/goat-spins-hp-slider-2.png";
import ChPromo_3 from "/public/assets/goat-spins-hp-slider-3.png";
// import ChPromo_4 from "/public/assets/ob-promo-4.webp";
import ChPromo_5 from "/public/assets/goat-spins-hp-slider-4.png";

import Image from "next/image";

// import { NavLink, useNavigate } from "react-router-dom";
import Link from "next/link";
import { useRouter } from "next/navigation";

import { AppContext } from "../context/AppContext";
import { GameContext } from "../context/GameContext";

export default function SliderPromoHome() {
  const { user, setIsClosed } = useContext(AppContext);
  const { startGame } = useContext(GameContext);
  // const navigate = useNavigate();
  const router = useRouter();

  const startGameOnClick = (gameId, machineId, gameName, link) => {
    if (!user) {
      setIsClosed(false);
      return;
    }

    // startGame(gameId, machineId, gameName, () => navigate(link));
    startGame(gameId, machineId, gameName, () => router.push(link));
  };

  return (
    <div className="ContProBoxes">
      <Swiper
        modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={22}
        slidesPerView={3}
        pagination={{ clickable: true }}
        centeredSlides={false}
        breakpoints={{
          200: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          600: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          700: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        // onSwiper={(swiper) => console.log(swiper)}
        autoplay={{
          delay: 3500,
          // delay: 9000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        navigation={true}
        className="mySwiper"
        // onSlideChange={() => console.log("slide change")}
      >
        <SwiperSlide
          onClick={() =>
            startGameOnClick(18, 443, "Regal Reels", "/regal-reels")
          }
        >
          <Link href="#" className="BoxPromosH_S">
            <div className="FrontProH_S">
              <h2 className="Promo-header">New Game</h2>
              <h1 className="Promo-text">Regal Reels</h1>
              <div className="BtnPromo">Play Now</div>
            </div>

            <div className="ChPromo Game">
              <Image
                width={170}
                height={170}
                // width={240}
                // height={240}
                src="/assets/goat-spins-regal-reels-instant-withdrawals.png"
                className="ImgChPromoGame"
                alt="New Game Clue Chronicles"
                priority={true}
              />
            </div>
            {/* <Image
              width={150}
              height={150}
              src={BgPromo_1}
              className="BgPromosH_S"
              alt="Eternal Slots"
            /> */}
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link
            href="https://cdk.goatspins.com:3072/lobby?SkinId=1&show=login"
            className="BoxPromosH_S"
          >
            <div className="FrontProH_S">
              <h2 className="Promo-header">GOAT Slots</h2>
              <h1 className="Promo-text">
                PLAY GOAT SLOTS <br />
                EVERYDAY
              </h1>
              <div className="BtnPromo">Play Now</div>
            </div>

            <div className="ChPromo">
              <Image
                width={170}
                height={170}
                // width={240}
                // height={240}
                src={ChPromo_1}
                className="ImgChPromo"
                alt="New Game Interstellar 7s"
                priority={true}
              />
            </div>
            {/* <img src={BgPromo_1} className="BgPromosH_S" alt="goat spins" /> */}
          </Link>
        </SwiperSlide>

        <SwiperSlide>
          <Link href="/promotions" className="BoxPromosH_S">
            <div className="FrontProH_S">
              <h2 className="Promo-header">Welcome Bonus</h2>
              <h1 className="Promo-text">
                WELCOME BONUS <br /> 388% + 150 SPINS
              </h1>
              {/* <h3>5X A DAY!</h3> */}
              <div className="BtnPromo">Grab it!</div>
            </div>
            <div className="ChPromo">
              <Image
                width={170}
                height={170}
                src={ChPromo_2}
                className="ImgChPromo"
                alt="goat-spins-25-no-rules-boost-instant-withdrawals"
                priority={true}
              />
            </div>
            {/* <img src={BgPromo_2} className="BgPromosH_S" alt="goat spins" /> */}
          </Link>
        </SwiperSlide>

        <SwiperSlide>
          <Link href="/promotions" className="BoxPromosH_S">
            <div className="FrontProH_S">
              <h2 className="Promo-header">Bonus</h2>
              <h1 className="Promo-text">
                GRAB FAST CASHOUTS <br /> 69% LOW WAGER
              </h1>
              {/* <h3>5X A DAY!</h3> */}
              <div className="BtnPromo">Grab it!</div>
            </div>
            <div className="ChPromo">
              <Image
                width={170}
                height={170}
                // width={240}
                // height={240}
                src={ChPromo_3}
                className="ImgChPromo"
                alt="goat-spins-25-no-rules-boost-instant-withdrawals"
                priority={true}
              />
            </div>
            {/* <img src={BgPromo_2} className="BgPromosH_S" alt="goat spins" /> */}
          </Link>
        </SwiperSlide>

        <SwiperSlide>
          <Link href="/vip-program" className="BoxPromosH_S">
            <div className="FrontProH_S">
              <h2 className="Promo-header">Our</h2>
              <h1 className="Promo-text">
                VIP
                <br />
                PROGRAM
              </h1>
              <div className="BtnPromo">Join Us!</div>
            </div>
            <div className="ChPromo">
              <Image
                width={170}
                height={170}
                // width={240}
                // height={240}
                src={ChPromo_5}
                className="ImgChPromo"
                alt="goat-spins-vip-instant-withdrawals"
                priority={true}
              />
            </div>
            {/* <img src={BgPromo_3} className="BgPromosH_S" alt="goat spins" /> */}
          </Link>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
